<template>
  <div class="locale-content">
    <p>
      CAnnect est un réseau social d'entreprise, un lieu d’échange professionnel dédié aux employés du Groupe IWM
      qui facilite la cohésion des équipes, le partage de connaissances et l'ancrage de nos pratiques Agile.
    </p>
    <p>
      Les utilisateurs peuvent créer des communautés publiques ou privées pour partager du contenu et leur
      compétences, leurs intérêts avec l'entreprise et leur équipe.
    </p>
    <p>
      Cette solution est née en novembre 2017 chez Crédit Agricole CIB, Indosuez a acquis les droits et adapté
      CAnnect à nos besoins en développant avec le Lab Innovation toute une série de nouvelles fonctionnalités.
    </p>
    <p>
      L'objectif est de vous offrir un espace pour partager et discuter d'idées avec une expérience utilisateur :
    </p>
    <ul>
      <li>100% sécurisée;</li>
      <li>Dynamique;</li>
      <li>Proche des besoins;</li>
      <li>Simple d'utilisation;</li>
      <li>Proche des usages d'aujourd'hui.</li>
    </ul>
    <p v-if="showCommunityHowTo">
      <strong>Pour en apprendre plus sur CAnnect, rendez-vous sur la communauté :</strong> <br />
      <span class="link" @click="goToHowTo()"><u>How to use CAnnect / Comment utiliser CAnnect</u></span>
    </p>
  </div>
</template>

<script>

export default {
  name: 'ReadAboutFr',
  props: {
    showCommunityHowTo: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goToHowTo() {
      this.$emit('goToCommunity')
    }
  }
}
</script>
